import { createReducer } from '@reduxjs/toolkit'

import { PATH_CHANGE } from 'actions/actionConstants'
import { LEFT_PANE_WIDTH_DEFAULT } from 'tripPlanner/cookies/leftPaneWidth'
import {
  setCurrentTripId,
  clearCurrentTripId,
  setCurrentSelectionId,
  clearCurrentSelectionId,
  setTripItemHasJustBeenAdded,
  toggleSubFilters,
  clearSubFilters,
  setSubFilters,
  setFirstTripItemHasJustBeenAdded,
  clearFirstTripItemHasJustBeenAdded,
  _setLeftPaneWidth,
} from 'tripPlanner/reducers/actions'

export const initialState: App.TripPlannerState = {
  currentTripId: undefined,
  currentSelectionId: undefined,
  tripItemHasJustBeenAdded: false,
  selectedSubFilters: [],
  firstTripItemHasJustBeenAdded: false,
  leftPaneWidth: LEFT_PANE_WIDTH_DEFAULT,
}

const tripPlannerReducer = createReducer<App.TripPlannerState>(
  initialState,
  (builder) => {
    builder.addCase(setCurrentTripId, (state, action) => ({
      ...state,
      currentTripId: action.payload,
    }))
    builder.addCase(clearCurrentTripId, (state) => ({
      ...state,
      currentTripId: undefined,
    }))
    builder.addCase(setCurrentSelectionId, (state, action) => ({
      ...state,
      currentSelectionId: action.payload,
    }))
    builder.addCase(clearCurrentSelectionId, (state) => ({
      ...state,
      currentSelectionId: undefined,
    }))
    builder.addCase(setTripItemHasJustBeenAdded, (state) => {
      state.tripItemHasJustBeenAdded = true
    })
    builder.addCase(setFirstTripItemHasJustBeenAdded, (state) => {
      state.firstTripItemHasJustBeenAdded = true
    })
    builder.addCase(clearFirstTripItemHasJustBeenAdded, (state) => {
      state.firstTripItemHasJustBeenAdded = false
    })
    builder.addCase(toggleSubFilters, (state, action) => {
      if (state.selectedSubFilters?.length > 0) {
        const includes = state.selectedSubFilters.includes(action.payload)
        state.selectedSubFilters = includes ?
            state.selectedSubFilters.filter((value) => value != action.payload) :
            [...state.selectedSubFilters, action.payload]
      } else {
        state.selectedSubFilters = [action.payload]
      }
    })
    builder.addCase(setSubFilters, (state, action) => {
      if (action.payload) {
        state.selectedSubFilters = action.payload
      }
    })
    builder.addCase(clearSubFilters, (state) => {
      state.selectedSubFilters = []
    })
    builder.addCase(_setLeftPaneWidth, (state, action) => {
      state.leftPaneWidth = action.payload
    })
    builder.addMatcher(
      (action) => action.type === PATH_CHANGE,
      (state) => {
        state.tripItemHasJustBeenAdded = false
        state.firstTripItemHasJustBeenAdded = false
      },
    )
  },
)

export default tripPlannerReducer
